import { Button } from '@heroui/react';
import styled from 'styled-components';

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  line-height: 1.6;
  margin: 0;
`;

export const ModalHeaderStyled = styled.div`
  padding: 24px 24px 12px 24px;
  border-bottom: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f9fafb' : '#111827')};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ModalBodyStyled = styled.div`
  padding: 24px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
`;

export const ModalFooterStyled = styled.div`
  padding: 16px 24px 24px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
`;

export const CancelButton = styled(Button)`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
  font-weight: 400;
  font-size: 12px;
  padding: 5px 12px;
  height: 30px;
  min-height: 30px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};
    border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#9ca3af')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled(Button)<{ $variant?: 'danger' | 'primary' }>`
  font-weight: 400;
  font-size: 12px;
  padding: 5px 12px;
  height: 30px;
  min-height: 30px;
  border-radius: 8px;
  transition: all 0.2s ease;

  ${({ $variant, theme }) => ($variant === 'danger'
    ? `
    background: transparent;
    color: #dc2626;
    border: 1px solid #dc2626;
    box-shadow: none;

    &:hover:not(:disabled) {
      background: ${theme.mode === 'dark' ? 'rgba(220, 38, 38, 0.12)' : '#fef2f2'};
      color: #b91c1c;
      border-color: #b91c1c;
    }
  `
    : `
    background: #111827;
    color: #ffffff;
    border: 1px solid transparent;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);

    &:hover:not(:disabled) {
      background: #000000;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.28);
    }

    ${theme.mode === 'dark' ? `
      background: #1f2937;
      border-color: #374151;

      &:hover:not(:disabled) {
        background: #111827;
      }
    ` : ''}
  `)}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }

  svg {
    flex-shrink: 0;
  }
`;
